import type {MathQuestionFillInTheBlanksMetadataAttrs} from '@freckle/educator-entities/ts/math/common/models/questions/question-fill-in-the-blanks'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'

type FillInTheBlanksReportCorrectAnswersProps = {
  metadata: MathQuestionFillInTheBlanksMetadataAttrs
}

export const FillInTheBlanksReportCorrectAnswers = (
  props: FillInTheBlanksReportCorrectAnswersProps
) => {
  const {
    metadata: {correctAnswers, rows, header}
  } = props
  const {t} = useSafeTranslation('common')

  let answerIndex = 0
  const decoratedAnswers = rows.reduce(
    (
      ansArray: {row: number; headerText: string; correctAnswer: string}[],
      columns,
      index: number
    ) => {
      columns.forEach((column, colIndex) => {
        if (column.tag === 'answers') {
          const decoratedAnswer = {
            row: index,

            headerText: header !== null && header !== undefined ? header[colIndex]! : '',

            correctAnswer: correctAnswers[answerIndex++]!
          }
          ansArray.push(decoratedAnswer)
        }
      })
      return ansArray
    },
    []
  )

  const decoratedCorrectAnswers = decoratedAnswers.map((ans, index) => {
    const {correctAnswer, row: rowIndex, headerText} = ans
    return (
      <div key={index}>
        {t('FILL_IN_THE_BLANKS_SAVED_ANSWER_ROW', {rowNumber: rowIndex + 1})} {headerText}:{' '}
        {correctAnswer}
      </div>
    )
  })

  return (
    <Flex flexDirection="column" justifyContent="space-between">
      {decoratedCorrectAnswers}
    </Flex>
  )
}
